<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()"><span>{{'Doris'|translate}}</span></a>
  </div>
  <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name |translate }}</nb-option>
  </nb-select>
</div>

<div class="header-container">
  <div class="row p-4" [dir]='apiService.currentDirection'>
    <p class="language" style="cursor: pointer" (click)="changeLang()" *ngIf="directionService.isRtl()"><i
        class="fa fa-globe"></i><span> En</span> </p>
    <p class="language" style="cursor: pointer" (click)="changeLang()" *ngIf="!directionService.isRtl()"> <i
        class="fa fa-globe"></i> <span style="font-family: 'vazir'!important;"> فا</span></p>
  </div>
  <nb-actions size="small">

    <!-- <nb-action class="control-item">
      <nb-search type="rotate-layout"></nb-search>
    </nb-action> -->

    <!-- <nb-action class="control-item" icon="" (click)="changeLang()"   badgeText="En" badgePosition="top right"
    ></nb-action> -->
    <!-- 
    <nb-action class="control-item" icon="email-outline"></nb-action>
    <nb-action class="control-item" icon="bell-outline"></nb-action> -->
    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
      <!-- <nb-user [nbContextMenu]="userMenu" [onlyPicture]="userPictureOnly" [name]="sepideh" [picture]="">
      </nb-user> -->

      <nb-user size="large" [name]="apiService.userInfo.fullName" title="{{'Admin'|translate}}" [nbContextMenu]="userMenu"
        [picture]="apiService.userInfo.base64" [nbContextMenuTag]="onMenuItemClick">
      </nb-user>

    </nb-action>
  </nb-actions>
</div>